const LEASING_COMPANIES_MUTATION_TYPES = Object.freeze({
  APPEND_LEASING_COMPANIES: 'APPEND_LEASING_COMPANIES',

  SET_ERROR: 'SET_ERROR',
});

export default LEASING_COMPANIES_MUTATION_TYPES;
